<script lang="ts">
	import { currency_code } from '$lib/cart';
	const size = 29;
</script>

{#if $currency_code === 'USD'}
	<button on:click={() => ($currency_code = 'EUR')}>
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512"
			><mask id="circleFlagsUs0"><circle cx="256" cy="256" r="256" fill="#fff" /></mask><g
				mask="url(#circleFlagsUs0)"
				><path
					fill="#eee"
					d="M256 0h256v64l-32 32l32 32v64l-32 32l32 32v64l-32 32l32 32v64l-256 32L0 448v-64l32-32l-32-32v-64z"
				/><path
					fill="#d80027"
					d="M224 64h288v64H224Zm0 128h288v64H256ZM0 320h512v64H0Zm0 128h512v64H0Z"
				/><path fill="#0052b4" d="M0 0h256v256H0Z" /><path
					fill="#eee"
					d="m187 243l57-41h-70l57 41l-22-67zm-81 0l57-41H93l57 41l-22-67zm-81 0l57-41H12l57 41l-22-67zm162-81l57-41h-70l57 41l-22-67zm-81 0l57-41H93l57 41l-22-67zm-81 0l57-41H12l57 41l-22-67Zm162-82l57-41h-70l57 41l-22-67Zm-81 0l57-41H93l57 41l-22-67zm-81 0l57-41H12l57 41l-22-67Z"
				/>
			</g>
		</svg>
	</button>
{:else if $currency_code === 'EUR'}
	<button on:click={() => ($currency_code = 'GBP')}>
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512"
			><mask id="circleFlagsEuropeanUnion0"><circle cx="256" cy="256" r="256" fill="#fff" /></mask
			><g mask="url(#circleFlagsEuropeanUnion0)"
				><path fill="#0052b4" d="M0 0h512v512H0z" /><path
					fill="#ffda44"
					d="m256 100.2l8.3 25.5H291l-21.7 15.7l8.3 25.6l-21.7-15.8l-21.7 15.8l8.3-25.6l-21.7-15.7h26.8zm-110.2 45.6l24 12.2l18.9-19l-4.2 26.5l23.9 12.2l-26.5 4.2l-4.2 26.5l-12.2-24l-26.5 4.3l19-19zM100.2 256l25.5-8.3V221l15.7 21.7l25.6-8.3l-15.8 21.7l15.8 21.7l-25.6-8.3l-15.7 21.7v-26.8zm45.6 110.2l12.2-24l-19-18.9l26.5 4.2l12.2-23.9l4.2 26.5l26.5 4.2l-24 12.2l4.3 26.5l-19-19zM256 411.8l-8.3-25.5H221l21.7-15.7l-8.3-25.6l21.7 15.8l21.7-15.8l-8.3 25.6l21.7 15.7h-26.8zm110.2-45.6l-24-12.2l-18.9 19l4.2-26.5l-23.9-12.2l26.5-4.2l4.2-26.5l12.2 24l26.5-4.3l-19 19zM411.8 256l-25.5 8.3V291l-15.7-21.7l-25.6 8.3l15.8-21.7l-15.8-21.7l25.6 8.3l15.7-21.7v26.8zm-45.6-110.2l-12.2 24l19 18.9l-26.5-4.2l-12.2 23.9l-4.2-26.5l-26.5-4.2l24-12.2l-4.3-26.5l19 19z"
				/></g
			></svg
		>
	</button>
{:else if $currency_code === 'GBP'}
	<button on:click={() => ($currency_code = 'CAD')}>
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512">
			<mask id="circleFlagsUk0">
				<circle cx="256" cy="256" r="256" fill="#fff" />
			</mask>
			<g mask="url(#circleFlagsUk0)">
				<path
					fill="#eee"
					d="m0 0l8 22l-8 23v23l32 54l-32 54v32l32 48l-32 48v32l32 54l-32 54v68l22-8l23 8h23l54-32l54 32h32l48-32l48 32h32l54-32l54 32h68l-8-22l8-23v-23l-32-54l32-54v-32l-32-48l32-48v-32l-32-54l32-54V0l-22 8l-23-8h-23l-54 32l-54-32h-32l-48 32l-48-32h-32l-54 32L68 0z"
				/>
				<path
					fill="#0052b4"
					d="M336 0v108L444 0Zm176 68L404 176h108zM0 176h108L0 68ZM68 0l108 108V0Zm108 512V404L68 512ZM0 444l108-108H0Zm512-108H404l108 108Zm-68 176L336 404v108z"
				/>
				<path
					fill="#d80027"
					d="M0 0v45l131 131h45zm208 0v208H0v96h208v208h96V304h208v-96H304V0zm259 0L336 131v45L512 0zM176 336L0 512h45l131-131zm160 0l176 176v-45L381 336z"
				/>
			</g>
		</svg>
	</button>
{:else if $currency_code === 'CAD'}
	<button on:click={() => ($currency_code = 'USD')}>
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512"
			><mask id="circleFlagsCa0"><circle cx="256" cy="256" r="256" fill="#fff" /></mask><g
				mask="url(#circleFlagsCa0)"
				><path fill="#d80027" d="M0 0v512h144l112-64l112 64h144V0H368L256 64L144 0Z" /><path
					fill="#eee"
					d="M144 0h224v512H144Z"
				/><path
					fill="#d80027"
					d="m301 289l44-22l-22-11v-22l-45 22l23-44h-23l-22-34l-22 33h-23l23 45l-45-22v22l-22 11l45 22l-12 23h45v33h22v-33h45z"
				/></g
			></svg
		>
	</button>
{/if}
